<template>
	<div class="select-matching-employee uk-margin-medium-top">

		<ul class="uk-tab" uk-switcher="animation: uk-animation-fade">
			<li class="uk-active"><a href="#certs">Suggested Matches</a></li>
			<li><a href="#train">Search</a></li>
		</ul>
		<ul class="uk-switcher">
			<li class="uk-container uk-container-expand">
				<div class="uk-flex uk-flex-start uk-flex-wrap uk-margin-medium-bottom">
					<div v-for="match in possibleMatches" class="uk-width-1-5@l uk-width-1-4@m uk-margin-small-right uk-margin-small-bottom match" :class="{'active':match.id == selectedMatch}" @click.prevent="selectMatch(match.id)">
						<span class="match-score">{{ match.score }}</span>
						{{ match.first_name }} {{ match.last_name }} <br />
						{{ match.id_number }}<br />
						{{ match.phone }} {{ match.email }} <br />
					</div>
				</div>
			</li>
			<li class="uk-container uk-container-expand">
				<div class="uk-grid table-filter">
					<div class="uk-width-1-2@xl uk-width-1-2@s  uk-margin-small-bottom">
						<label for="pf-search" class="uk-form-label">Search</label>
						<div class="uk-form-controls">
							<input
								id="pf-search"
								type="text"
								name="pf-search"
								value=""
								class="uk-input"
								v-model="searchTerm"
								placeholder="Enter Search Terms"
							/>
						</div>
					</div>

					<div class="uk-width-1-2@l">
						<div class="uk-form-label uk-margin-top">Narrow Search By</div>
						<label class="uk-display-block">
							<input class="uk-radio" type="radio" value="name" v-model="selectedFilter" />
							Name
						</label>
						<label class="uk-display-block">
							<input class="uk-radio" type="radio" value="emp" v-model="selectedFilter" />
							Employee #
						</label>
						<label class="uk-display-block">
							<input class="uk-radio" type="radio" value="ssn" v-model="selectedFilter" />
							SSN (Last 4)
						</label>
						<label class="uk-display-block">
							<input class="uk-radio" type="radio" value="phone" v-model="selectedFilter" />
							Phone #
						</label>
					</div>
				</div>
				<button v-if="!searching" class="uk-button uk-button-primary" @click="startSearch">
					Search
				</button>
				<div class="uk-margin-medium-top">
					<pagination
						ref="pager"
						:count="pagination.count"
						:page="pagination.page"
						:per_page="pagination.limit"
						v-on:page="goToPage"
						:bottom="true"
					></pagination>
					<div class="uk-clearfix"></div>
					<div class="uk-flex uk-flex-start uk-flex-wrap uk-margin-medium-bottom">
						<div v-for="match in searchedPersons" class="uk-width-1-5@l uk-width-1-4@m uk-margin-small-right uk-margin-small-bottom match" :class="{'active':match.id == selectedMatch}" @click.prevent="selectMatch(match.id)">
							{{ match.first_name }} {{ match.last_name }} <br />
							{{ match.id_number }}<br />
							{{ match.phone }} {{ match.email }} <br />
						</div>
					</div>
				</div>
			</li>
		</ul>
		<a v-if="selectedMatch != null" class="uk-button uk-button-primary uk-align-right" :href="'/paylocity/merge/person/' + paylocityId + '/' + selectedMatch">Import Data</a>
		<a v-if="selectedMatch == null" class="uk-button uk-button-danger uk-align-right" :href="'/paylocity/create/person/' + paylocityId">Create New Employee</a>
	</div>
</template>

<script>
import Pagination from "./Table/Pagination";
export default {
	name: "SelectMatchingEmployee",
	components:{
		Pagination
	},
	props:{
		paylocityId:{
			type: Number,
			default: null
		}
	},
	data() {
		return {
			possibleMatches:[],
			searchedPersons:[],
			selectedFilter:"name",
			searchTerm: "",
			selectedMatch:null,
			searching: false,
			pagination:{
				page:1,
				limit:30,
				count: 0
			},
		}
	},
	mounted() {
		this.getPossibleMatches();
	},
	methods: {
		getPossibleMatches(){
			axios.get("/api/paylocity/matches/" + this.paylocityId).then(
				(pack) => this.loadMatches(pack)
			).catch(
				() => this.failMatches()
			)
		},
		loadMatches(pack){
			if(pack.data.success){
				this.possibleMatches = pack.data.data;
			}
		},
		failMatches(){
			this.possibleMatches = [];
		},
		selectMatch(id){
			if(this.selectedMatch == id){
				this.selectedMatch = null;
			} else {
				this.selectedMatch = id;
			}
		},
		startSearch(){
			this.pagination.page = 1;
			let qItems = {
				q: this.searchTerm,
				//notPaylocity: true,
				limit: this.pagination.limit,
				page: this.pagination.page,
				filters: [this.selectedFilter]
			};
			this.searching = true;
			axios.get("/api/employee/list", {params: qItems}).then(
				(pack) => this.loadSearch(pack)
			).catch(
				() => this.failSearch()
			)
		},
		goToPage(i){
			this.searching = true;
			let qItems = {
				q: this.searchTerm,
				notPaylocity: true,
				limit: this.pagination.limit,
				page: i,
				filters: [this.selectedFilter]
			};
			axios.get("/api/employee/list", {params: qItems}).then(
				(pack) => this.loadSearch(pack)
			).catch(
				() => this.failSearch()
			)
		},
		loadSearch(pack){
			this.searching = false;
			if(pack.data.success){
				this.searchedPersons = pack.data.data;
				this.pagination.page = pack.data.pagination.page;
				this.pagination.limit = pack.data.pagination.limit;
				this.pagination.count = pack.data.pagination.total;
				//this.$refs.pager.$forceUpdate();
			}
		},
		failSearch(){
			this.searching = false;
			this.searchedPersons = [];
		}
	}
}
</script>
<style scoped></style>